<template>
    <b-container>
      <question-header class="head-ques" />

      <question-content :question="question" />

      <question-answer :question-options="questionOptions"
                       :question-number="questionNumber"
                       :question-id="questionId"
                       class="answers"
                       @questionAnswered="isQuestionAnswered=true">
      </question-answer>

      <question-next :question-number="questionNumber" :show-button-next="isQuestionAnswered" />
    </b-container>
</template>

<script>
  import QuestionHeader from "../Components/QuestionHeader.vue"
  import QuestionContent from "../Components/QuestionContent.vue"
  import QuestionAnswer from "../Components/QuestionAnswer.vue"
  import QuestionNext from "../Components/QuestionNext.vue"
  import {Storage} from '../../../core/Utils'

  export default {
    name: "UserQuestions",
    components: {QuestionHeader, QuestionContent, QuestionAnswer, QuestionNext},
    data() {
      return {
        question: {},
        questionId: '',
        questionOptions: [],
        questionNumber: null,
        isQuestionAnswered: false,
      }
    },
    methods: {
      getCurrentQuestion: function () {
        const questionList = Storage.getQuestions()
        this.question = questionList[this.questionNumber - 1]
        this.questionOptions = this.shuffle(this.question["options"])
        this.questionId = this.question["id"]
      },
      shuffle: function (array) {
        let currentIndex = array.length, randomIndex;

        while (currentIndex !== 0) {
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex--;

          [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
        }
        return array;
      }
    },
    watch: {
      '$route.params.questionNumber': {
        handler: function (questionNumber) {
          if (typeof questionNumber === 'string') {
            this.questionNumber = parseInt(questionNumber);
          } else {
            this.questionNumber = questionNumber;
          }
        },
        deep: true,
        immediate: true
      },
      'questionNumber': {
        handler: function() {
          this.getCurrentQuestion()
          this.isQuestionAnswered = false
        },
        immediate: true
      },
    }
  }
</script>

<style lang="stylus" scoped>

  .head-ques
    width 90%
    margin-left auto
    margin-right auto
  .answers
    width 90%

</style>
